/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../../DataProvider";
import DataWidget from "../DataWidget";
import ViewArray from "./ViewArray";

class ViewObject extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string
    };

    static defaultProps = {
        field: null
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderItems() {
        let items = [];
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider;

        let schema = dataProvider.getSchema();
        let parentField = this.props.field;
        if (parentField) {
            schema = schema.field(parentField);
            parentField += "/";
        }
        else parentField = "";
        let fieldList = schema.getFieldList();
        if (!fieldList) return null;

        for (let f of fieldList) {
            let field = parentField + f;
            let title = dataProvider.getSchema().field(field).getTitle();
            if (dataProvider.getValue(field) == null) continue;
            items.push((<dt key={field+"-dt"}>{title + ":"}</dt>));
            items.push((<dd key={field+"-dd"}><DataWidget dataProvider={dataProvider} field={field} /></dd>));
        }
        return items;
    }

    render() {
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider;
        let itemsSchema = dataProvider.getSchema().field(this.props.field + "/items");
        if (itemsSchema && itemsSchema.getType() === "array") {
            // Show directly array data:
            return (<ViewArray dataProvider={dataProvider.getProvider(this.props.field)} field="items"/>);
        }
        return (
            <dl className="dl-horizontal">
                {this.renderItems()}
            </dl>
        );
    }
}

export default ViewObject;
